import "reflect-metadata"
import { injectable } from 'inversify-props';
import { PISServiceAdapter } from '@/usecases/impostos/adapter/PISServiceAdapter';
import { getPIS, findPIS } from '@/api/impostos';

@injectable()
export class PISService implements PISServiceAdapter {
	get = async (id: string) => await getPIS(id)
	find = async(params: any) => await findPIS(params)
}